import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// ---------------------------------------------------------------------------
// Auth-drift interceptor
// ---------------------------------------------------------------------------
// If the backend rejects a request with 401, 403, or 409 for reasons that hint
// at "you're not who the UI thinks you are" (session expired, contact assigned
// to a different user, etc.) we ping the AuthContext to re-fetch /auth/me. The
// context compares the returned user id to what it has in memory and, on drift,
// reloads the page so the UI reflects the actual signed-in account.

let driftHandler = null;

export function registerAuthDriftHandler(fn) {
  driftHandler = fn;
}

const DRIFT_MESSAGE_HINTS = [
  "assigned to another user",
  "assigned to another",
  "already claimed by another",
  "not authenticated",
  "invalid token",
  "session",
];

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const cfg = error?.config || {};
    const url = cfg.url || "";
    // Don't recurse on /auth/me itself.
    if (driftHandler && !url.includes("/auth/me")) {
      if (status === 401) {
        driftHandler();
      } else if ((status === 403 || status === 409)) {
        const detail = String(error?.response?.data?.detail || "").toLowerCase();
        if (DRIFT_MESSAGE_HINTS.some((h) => detail.includes(h))) {
          driftHandler();
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
